import React from "react";


const RewardContent = (props) => {
  // const [buttonText, setButtonText] = useState("View My Wallets");

  // // Handle Copy Button Click
  // const handleCopyClick = () => {
  //   const codeText = document.querySelector(".code mark").textContent;
  //   const textarea = document.createElement("textarea");
  //   document.body.appendChild(textarea);
  //   textarea.value = codeText;
  //   textarea.select();

  //   try {
  //     document.execCommand("copy");
  //     setButtonText("Copied!");

  //     // Reset text after 2 seconds
  //     setTimeout(() => {
  //       setButtonText("Copy");
  //     }, 2000);
  //   } catch (err) {
  //     console.error("Copy failed", err);
  //   }

  //   document.body.removeChild(textarea);
  // };

  return (
    <section
      id="id_memecoin_service_section"
      className={`memecoin_service_section bg-white section_space z-2 pt-0 pb-0 position-relative ${props.tokenClass}`}
    >
    
      <div class="container">
        <div class="row justify-content-center">
          {/* <div className="col-lg-6"> */}
          <div className="col-lg-12">
            {/* <div className="border-end px-4"> */}
            <div>
              <div className="mt-4">
                <h1 className=" text-theme">
                  Discover the True Value of Your TopCoin UK Rewards
                </h1>
                <p className="text-dark opacity-50">
                  At every level, your loyalty unlocks more value, in both
                  TopCoin and cash.
                </p>
                <p className="text-dark opacity-50">
                  To find out how much your TopCoin is worth, simply add the
                  total value from each level you’ve reached, including both
                  TopCoin balances and unlocked cash wallets.
                </p>
                <p className="text-dark opacity-50">
                  Our goal is to help you reach the highest level, where your
                  TopCoin could be worth £100,000 or more. Because here,
                  loyalty truly pays.
                </p>
                <p className="text-dark opacity-75 mb-0">
                  Understanding the Cash Wallets System
                </p>

                <p className="text-dark opacity-75 mb-0">
                  (Separate from Your TopCoin Wallets)
                </p>
                <div className="card bg-white border border-opacity-75 shadow-sm mt-3">
                  <div className="card-body">
                    <h5 className="fw-medium text-dark-emphasis fw-bold">
                      These cash rewards are released automatically as you
                      progress through your TopCoin Wallets:
                    </h5>
                    <ul className="text-dark-emphasis opacity-75 py-2 mb-0">
                      <li>Second TopCoin Wallet unlocks TopCoin Cash Wallet 1</li>
                      <li>Third TopCoin Wallet unlocks TopCoin Cash Wallet 2</li>
                      <li>Fourth TopCoin Wallet unlocks TopCoin Cash Wallet 3</li>
                      <li>Fifth TopCoin Wallet unlocks TopCoin Cash Wallet 4</li>
                      <li>Sixth TopCoin Wallet unlocks TopCoin Cash Wallet 5</li>
                      <li>Seventh TopCoin Wallet unlocks TopCoin Cash Wallet 6</li>
                      <li>Eighth TopCoin Wallet unlocks TopCoin Cash Wallet 7</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="mt-4">
                <h2 className=" text-theme">
                  How Is Your Cash Share Calculated?
                </h2>
                <ul className="text-dark-emphasis">
                  <li>Total TopCoin across all customers: 1,000,000</li>
                  <li>Your TopCoin at that level: 25,000</li>
                  <li>Cash in the wallet: £20,000</li>
                </ul>
                <div className="d-flex flex-column text-dark-emphasis gap-3">
                  <div className="shadow-sm border bg-white p-3 border-opacity-20 rounded-3">
                    <h5 className="text-dark-emphasis">Step 1:</h5>
                    <p className="mb-0">
                      £20,000 ÷ 1,000,000 TopCoin = £0.02 per TopCoin
                    </p>
                  </div>
                  <div className="shadow-sm border bg-white p-3 border-opacity-20 rounded-3">
                    <h5 className="text-dark-emphasis">Step 2:</h5>
                    <p className="mb-0">25,000 TopCoin x £0.02 = £500 for you</p>
                  </div>
                  <div className="shadow-sm border bg-white p-3 border-opacity-20 rounded-3">
                    <h5 className="text-dark-emphasis">Step 3:</h5>
                    <p className="mb-0 fw-bold">
                      What is My TopCoin UK Wallets net worth?
                    </p>
                    <p>
                      Adding TopCoin Value + TopCoin Cash UK Value £100
                      + £ 500 = £600.00
                    </p>
                  </div>
                </div>
                {/* <h4 className="mt-3 text-theme">
                  What Is My TopCoin UK Worth?
                </h4> */}
                <div className="d-flex flex-column mt-3 gap-3">
                  <div className="shadow-sm border bg-white p-3 border-opacity-20 rounded-3">
                    <h5 className="text-dark-emphasis">
                      To calculate your total value:
                    </h5>
                    <ul className="mb-0 text-dark-emphasis">
                      <li>
                        1. Add up the cash from every TopCoin UK Cash Wallet
                        you’ve unlocked
                      </li>
                      <li>2. Add that to the TopCoin UK in your TopCoin Wallets</li>
                    </ul>
                  </div>
                  <div className="text-center text-dark-emphasis">
                    <p>
                      The total shows the real value of your journey with
                      TopCoin.
                    </p>
                  </div>
                </div>
              </div>
              <div className="p-3 border text-center shadow-sm bg-primary rounded-5">
                <h5 className="mb-0 text-white">
                  Loyalty. Progress. Real Cash Rewards.
                </h5>
              </div>
            </div>
          </div>
          {/* <div className="col-lg-6">
            <div className="bg-primary rounded-4 mt-4 p-4">
              <div className="">
                <h1 className="text-white">
                  Welcome to TopCoin UK - Where Loyalty Turns into Real Rewards!
                </h1>
                <p className="text-white opacity-50">
                  Once someone joins TopCoin UK, they’re given their own
                  Personal ID and Referring customer’s numbers — instantly unlocking access to our
                  powerful earning system.
                </p>

                <div className="card bg-white border border-opacity-75 shadow-sm mt-3">
                  <div className="card-body">
                    <h5 className="fw-medium text-dark-emphasis fw-bold">
                      How Agents Earn Free TopCoin UK:
                    </h5>
                    <p className="text-dark-emphasis mb-1">
                      As a TopCoin UK Agent, you earn free units effortlessly
                      every time you refer someone!
                    </p>
                    <ul className="text-dark-emphasis opacity-75 py-2 mb-0">
                      <li> When someone you introduce makes a purchase,</li>
                      <li>And they enter yourReferring customer’s numbers,</li>
                      <li>
                        You’ll instantly receive the same number of TopCoin they
                        earn — automatically!
                      </li>
                    </ul>
                    <p className="mb-1 text-dark-emphasis">
                      The person must be a registered TopCoin UK member.
                    </p>
                    <p className="mb-0 text-dark-emphasis">
                      They must enter your Referring customer’s numbers at checkout.
                    </p>
                  </div>
                </div>
                <div className=" py-4">
                  <p className="mb-1 text-white opacity-50">
                    The more people you refer, the more your TopCoin balance grows
                    — and with it, your TopCoin UK wallet power. Start sharing.
                    Start earning. Be the reason others discover TopCoin UK —
                    and get rewarded every step of the way.
                  </p>
                  <p className="text-white opacity-50 mb-0">
                    Your loyalty is your power. Make it count.
                  </p>
                </div>
              </div>
            </div> */}
            {/* <div>
              <div className="card bg-primary shadow-sm border-primary-subtle rounded-3 my-2">
                <div className="card-body">
                  <h5 className="mb-0">Wallet 1</h5>
                  <p className="mb-0">from 1 to 19,999 units</p>
                </div>
              </div>
              <div className="card bg-primary shadow-sm border-primary-subtle rounded-3 my-2">
                <div className="card-body">
                  <h5 className="mb-0">Wallet 2</h5>
                  <p className="mb-0">
                    from 20,000 to 199,999 units at the start this wallet is
                    worth worth £100
                  </p>
                </div>
              </div>
              <div className="card bg-primary shadow-sm border-primary-subtle rounded-3 my-2">
                <div className="card-body">
                  <h5 className="mb-0">Wallet 3</h5>
                  <p className="mb-0">
                    from 200,000 to 1,999,999 unit at the start this wallet is
                    worth £1000
                  </p>
                </div>
              </div>

              <div className="card bg-primary shadow-sm border-primary-subtle rounded-3 my-2">
                <div className="card-body">
                  <h5 className="mb-0">Wallet 4</h5>
                  <p className="mb-0">
                    from 2,000,000 to 9,999,999 at the start this wallet is
                    worth £10,000
                  </p>
                </div>
              </div>
              <div className="card bg-primary shadow-sm border-primary-subtle rounded-3 my-2">
                <div className="card-body">
                  <h5 className="mb-0">Wallet 5</h5>
                  <p className="mb-0">
                    from 10,000,000 to 19,999,999 at the start this wallet it’s
                    worth £50,000
                  </p>
                </div>
              </div>
              <div className="card bg-primary shadow-sm border-primary-subtle rounded-3 my-2">
                <div className="card-body">
                  <h5 className="mb-0">Wallet 6</h5>
                  <p className="mb-0">
                    20,000,000 Plus hit this wallet and you have earned £100,000
                    Plus
                  </p>
                </div>
              </div>
            </div> */}
          {/* </div> */}
        </div>
      </div>
    </section>
  );
};

export default RewardContent;
